import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { DataProvider } from './context/DataContext'
import { AnalyticsProvider } from './context/AnalyticsContext'
import ViewStateHandler from './ViewStateHandler'

let frameHeight: number | undefined = 0

const App: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    updateSize()
  }, [])

  const updateSize = (): void => {
    const innerHeight: number | undefined = containerRef?.current?.offsetHeight
    if (innerHeight === frameHeight) return
    frameHeight = innerHeight

    const payload = {
      msgType: 'childHeightChanged',
      height: frameHeight,
    }

    window.parent.postMessage(payload, '*')
  }

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize)

    return () => {
      window.removeEventListener('resize', updateSize)
    }
  }, [])

  return (
    <AnalyticsProvider>
      <DataProvider>
        <div
          ref={containerRef}
          className="relative flex flex-col bg-black overflow-hidden h-screen-xs sm:h-screen-sm md:h-screen-md lg:h-screen-lg xl:h-screen-xl 2xl:h-screen-2xl"
        >
          <ViewStateHandler />
        </div>
      </DataProvider>
    </AnalyticsProvider>
  )
}

export default App
